export default __webpack_public_path__ + "static/media/r-lemon-tree-tablet@3x.d19003bb.png";